import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { Messages } from "../../../model/messages";
import { Involved } from "../../../model/involved";
import { Navigation } from "../../../model/navigation";
import { Ticket } from "../../../model/ticket";
import { InvolvedService } from "../../../services/involved.service";
import { NavigationHelper } from "../../../services/navigation.helper";
import { TicketService } from "../../../services/ticket.service";
import { UsersService } from "../../../services/users.service";

@Component({
    selector: "involved",
    templateUrl: "./involved.component.html",
    styleUrls: ["./involved.component.css"],
})
export class InvolvedComponent implements OnInit {
    messages: BehaviorSubject<Messages> = new BehaviorSubject(Messages.EMPTY);
    involveds: BehaviorSubject<Involved[]> = new BehaviorSubject<Involved[]>([]);
    @Input() currentTicket: Observable<Ticket>;
    @Input() isMobile: boolean = false;
    @Output() involvedSelected = new EventEmitter<number>();
    @Output() refreshTimeline = new EventEmitter<void>();

    currentId: number | null = null;
    showCreateForm: boolean = false;
    showDetails: boolean = false;
    editMode: boolean = false;
    selectedInvolved: Involved | null = null;

    constructor(
        private involvedService: InvolvedService,
        private authService: AuthService,
        private router: Router,
        private nav: NavigationHelper,
        private ticketService: TicketService,
        private users: UsersService
    ) {
        this.messages = new BehaviorSubject(Messages.EMPTY);
        this.involveds = new BehaviorSubject<Involved[]>([]);
    }

    ngOnInit(): void {
        if (this.currentTicket) {
            this.currentTicket.subscribe((ticket) => {
                if (ticket) {
                    this.currentId = ticket.id;

                    if (ticket.parts?.ticketInvolved) {
                        this.involvedService.accept(ticket.parts.ticketInvolved);
                    } else {
                        this.involvedService.accept([]);
                    }
                }
            });
        }

        this.involvedService.involvedObservable.subscribe((involved) => {
            this.involveds.next(involved);
        });

        this.nav.fragmentId.subscribe((id) => {
            if (this.nav.currentFragmentTopic === "involved") {
                const fragmentId = Number(id);
                if (fragmentId === -9) {
                    this.showCreateForm = true;
                    this.editMode = true;
                }
            }
        });
    }

    userLabel(involved: Involved): string {
        return this.users.labelForId(Number(involved.involved));
    }

    createInvolved(): void {
        this.selectedInvolved = null;
        this.showCreateForm = true;
        const url = `tickets/${this.currentId}/fragmentedit/involved/${Navigation.NEW}`;
        this.router.navigate([url]).then(() => {
            this.involvedSelected.emit(Navigation.NEW);
        });
    }

    removeInvolved(involved: Involved): void {
        const token = this.authService.token;
        if (involved && involved.id && involved.ticketId) {
            this.involvedService
                .deleteInvolved(token, involved.ticketId, involved.id)
                .subscribe({
                    next: (response) => {
                        this.messages.next(response);
                        this.ticketService.getTicketWithParts(token, involved.ticketId).subscribe();
                        this.refreshTimeline.emit();
                    },
                    error: () => {
                        this.messages.next(Messages.from({ involved: ["involved.delete.failed"] }));
                    }
                });
        }
    }

    onFormClosed(): void {
        this.showCreateForm = false;
        this.selectedInvolved = null;
    }
}